import { CheckIcon } from '@heroicons/react/20/solid';
import { CONTACT_EMAIL } from '../lib/contact';
import { Card } from './ui';

export function AboutPage() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100 mb-4">About Chores Champ</h1>
      <Card padding="lg" className="max-w-xl">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-700 text-white shadow-sm dark:shadow-none">
            <CheckIcon className="h-6 w-6" aria-hidden="true" />
          </span>
          <h2 className="text-lg font-bold tracking-tight text-gray-900 dark:text-gray-100">Chores Champ</h2>
        </div>
        <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
          Keep track of the chores that come back again and again, and share them with the people you
          live with. Chores Champ works offline and syncs across your devices when you're back online.
        </p>
        <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
          You can use Chores Champ on this phone without an account; everything stays on the phone.
          Sign in to sync your chores across devices and share a household. Signing in to an existing
          account is always open, but creating one takes a code: write to {CONTACT_EMAIL} to ask for one.
        </p>
        <p className="mt-4 text-xs text-gray-500 dark:text-gray-400">
          {__GIT_VERSION__} ({__GIT_BRANCH__})
        </p>
      </Card>
    </div>
  );
}
